<!--
 * @Author: 月魂
 * @Date: 2021-06-08 09:04:57
 * @LastEditTime: 2021-12-24 16:05:49
 * @LastEditors: 月魂
 * @Description:
 * @FilePath: \nep-qin\src\components\footer.vue
-->
<template>
  <div class="footer">
    <div class="pc">
      <div class="cont">
        <el-row :gutter="10" class="cont-row">
          <el-col v-for="(item, index) in $t('footer')" :key="index" :span="12">
            <div class="cont-menu">
              <div class="cont-footer-menu">
                <div class="footer-title"><p>{{ item.title }}</p></div>
                <div class="footer-des"><p v-for="node in item.item" :key="node">{{ node }}</p></div>
              </div>
              <!-- <el-row :gutter="10">
                <el-col :span="6"><p>{{item.title}}</p></el-col>
                <el-col :span="18"><p v-for="node in item.item" :key="node">{{ node }}</p></el-col>
              </el-row> -->
            </div>
          </el-col>
        </el-row>
        <!-- <share :config="config"></share> -->
        <div class="num" style="text-align: center;width: 100%;margin-top: 10px">Visitors: {{ this.sum }}</div>
        <div class="icon">
          <a
            href="http://twitter.com/share?url=http://nep-qin.topartsintermational.com/&title=QIN"
            target="_blank"
          >
            <img src="../assets/t.png" width="30px" height="30px">
          </a>
          <a
            href="http://www.facebook.com/sharer.php?u=http://nep-qin.topartsintermational.com/&title=QIN"
            target="_blank"
          >
            <img src="../assets/f.png" width="30px" height="30px">
          </a>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div v-for="(item, index) in $t('footer')" :key="index" class="footer-menu">
        <van-row>
          <van-col span="8">{{ item.title }}</van-col>
          <van-col span="16">
            <p v-for="node in item.item" :key="node">{{ node }}</p>
          </van-col>
        </van-row>
        <!-- <div class="footer-menu">
          <div class="footer-title"><p>{{item.title}}</p></div>
          <div class="footer-des"><p v-for="node in item.item" :key="node">{{ node }}</p></div>
        </div> -->
      </div>
      <div class="num" style="text-align: center;width: 100%;margin-top: 10px">Visitors: {{ this.sum }}</div>
      <div class="icon">
        <a
          href="http://twitter.com/share?url=http://nep-qin.topartsintermational.com/&title=QIN"
          target="_blank"
        >
          <img src="../assets/t.png" width="30px" height="30px">
        </a>
        <a
          href="http://www.facebook.com/sharer.php?u=http://nep-qin.topartsintermational.com/&title=QIN"
          target="_blank"
        >
          <img src="../assets/f.png" width="30px" height="30px">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import Share from 'vue-social-share'
import 'social-share.js/dist/css/share.min.css'
import { Row, Col } from 'vant'
Vue.use(Row).use(Col).use(Share)

export default {
  name: 'Footer',
  data() {
    return {
      sum: null,
      config: {
        url: 'http://nep-qin.topartsintermational.com/',
        title: 'QIN',
        source: 'http://nep-qin.topartsintermational.com/',
        image: 'http://image.qinwen100.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20210621092946.jpg',
        sites: [ 'facebook', 'twitter' ]
      }
    }
  },
  mounted() {
    axios.get('/visitors/NEP-QIN').then(res => {
      this.sum = res.data;
    })
    axios.post('/visitors/NEP-QIN')
  }
}
</script>

<style scoped lang="less">
.footer {
  padding: 16px 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  .mobile {
    width: 100%;
    display: block;
  }
  .pc {
    width: 100%;
    display: none;
  }
  .icon {
    display: flex;
    justify-content: center;
    margin-top: 8px;
    a {
      margin-right: 10px;
    }
  }
  .footer-menu {
    width: 100%;
    color: #fff;
    p {
      margin: 0;
      padding: 0;
      line-height: 24px;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .cont {
    max-width: 1200px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    .icon {
      width: 100%;
    }
  }
  .cont-row {
    width: 100%;
  }
  .cont-menu {
    color: #fff;
  }
  .cont-menu p {
    margin: 0;
    padding: 0;
    line-height: 24px;
    font-size: 14px;
    font-weight: 500;
  }
  .cont-footer-menu {
    display: flex;
  }
  @media (min-width: 800px) {
    .pc {
      display: block;
    }
    .mobile {
      display: none;
    }
  }
}
</style>
